import axios from 'axios'
import { useAuthStore } from '~/store/auth'

const templateError = { success: false, message: 'Unknown error' }

export default defineNuxtPlugin((nuxtApp) => {
	const auth = useAuthStore()
	const config = useRuntimeConfig()

	// ✅ composable OK aquí (estamos dentro del plugin)
	const tokenCookie = useCookie<string | null>(config.public.auth.name_cookie)

	// (opcional pero recomendado) hidrata token del store en SSR
	if (import.meta.server && tokenCookie.value && auth.token !== tokenCookie.value) {
		auth.token = tokenCookie.value
	}

	const client = axios.create({
		baseURL: config.public.apiLotteries,
	})

	client.interceptors.request.use((req) => {
		// ❌ NO useCookie() aquí
		const token = auth.token || tokenCookie.value

		if (token) {
			req.headers = req.headers || {}
			req.headers.Authorization = `Bearer ${token}`
		}

		return req
	})

	client.interceptors.response.use(
		(res) => res,
		(error) => {
			if (!error.response) return Promise.reject({ data: templateError })
			return Promise.reject({
				data: { ...error.response.data, statusCode: error.response.status },
			})
		},
	)

	nuxtApp.provide('fetchLotteries', client)
})
